import { toast } from "react-toastify";
import axios from "axios";
import { fetchOrgs } from "../components/OrganisationManagement/OrganisationActions";
import { fetchProjects, selectProject } from "../components/Projects/ProjectActions";
import { fetchUsers } from "../components/UserManagement/UserActions";
import { logout } from "./slices/authSlice";
import { clearOrganisations } from "./slices/organisationsSlice";
import { clearProjects } from "./slices/projectsSlice";
import { clearUsers } from "./slices/usersSlice";
import { fetchThemes } from "../components/ThemeManagement/ThemeActions";
import { clearThemes } from "./slices/themesSlice";
import { fetchFiles } from "../components/Attachments/AttachmentActions";

export const fetchAllObjects = (dispatch) => {
    fetchOrgs(dispatch);
    fetchProjects(dispatch);
    fetchUsers(dispatch);
    fetchThemes(dispatch);
    fetchFiles(dispatch);
    if (localStorage.getItem('selectedProject')) {
        selectProject(localStorage.getItem('selectedProject'), dispatch);
    }
};

export const handleLogout = (dispatch) => {
    console.log("Logging out...");
    axios
        .post(
            'auth/logout/',
            {},
            { withCredentials: true }
        )
        .then(() => {
            toast.success("Uitgelogd");
        })
        .catch((err) => {
            /* Redux + localStorage are cleared in finally. HttpOnly refresh cookie can only be removed by the server (successful POST); if this request failed, a full reload might still restore the session via /auth/refresh/. */
            console.warn("Logout request failed:", err);
            toast.error("Er is iets misgegaan bij het uitloggen.");
        })
        .finally(() => {
            dispatch(clearOrganisations());
            dispatch(clearProjects());
            dispatch(clearUsers());
            dispatch(clearThemes());
            localStorage.removeItem('selectedProject');
            dispatch(logout());
        });
};
